type Variant = 'sign' | 'full';
type Size = 'sm' | 'md' | 'lg';

export interface BrandMarkProps {
  variant?: Variant;
  size?: Size;
  showSubBadge?: boolean;
}

const signSize: Record<Size, string> = {
  sm: 'h-6 w-auto',
  md: 'h-7 w-auto',
  lg: 'h-9 w-auto',
};

const fullSize: Record<Size, string> = {
  sm: 'h-5 w-auto',
  md: 'h-6 w-auto',
  lg: 'h-8 w-auto',
};

export default function BrandMark({
  variant = 'sign',
  size = 'md',
  showSubBadge = true,
}: BrandMarkProps) {
  return (
    <div className="flex items-center gap-2.5">
      {variant === 'sign' ? (
        <img
          src="/logo-sign.svg"
          alt="Avocado"
          className={signSize[size]}
          draggable={false}
        />
      ) : (
        <img
          src="/logo-full.svg"
          alt="Avocado"
          className={fullSize[size]}
          draggable={false}
        />
      )}
      {variant === 'sign' && showSubBadge && (
        <span className="rounded-full border border-ink-700 bg-ink-900/80 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-[0.18em] text-ink-300">
          Solana
        </span>
      )}
    </div>
  );
}
